import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-warranty-dealer-code',
  templateUrl: './warranty-dealer-code.component.html',
  styleUrls: ['./warranty-dealer-code.component.scss']
})
export class WarrantyDealerCodeComponent implements OnInit {

  public userId: any;
  public WDCListSelect: any = [];
  public showSelect: boolean = false;
  public selectedWDC: string = '';
  public showManage: boolean = false;
  public sessionId: any;
  public globalServices: any = [];
  public targetEngineServiceResponseObj: any;
  public globalManagedRes: any;
  public isEnableService: boolean = false;
  resume: boolean = false;
  pageData: any;
  viewRepairQualification: boolean = false;
  serviceNameListSubscription: Subscription = new Subscription;
  userIdSubscription: Subscription = new Subscription;
  WDCSubsciption: Subscription = new Subscription;
  resumeSubscription: Subscription = new Subscription;
  changeWBCPopUpClickStatus: boolean = false;
  isHighlighted: boolean = false;
  @ViewChild('confirmWDCPopUp') confirmWDCPopUp: ElementRef | undefined;
  @ViewChild('customerPaidPopUp') customerPaidPopUp:ElementRef | undefined;
  @ViewChild('selectWDC') selectWDC: ElementRef | undefined;
  
constructor(private service: ApifirstService, public router: Router, public rpcClient: RpcClientService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.sessionId = localStorage.getItem("sessionID");
    //update page number
    const req = {
      "sessionId": localStorage.getItem("sessionID"),
      "pageid": "22"
    }
    this.service.updatePage(req).subscribe(data => { })

    this.serviceNameListSubscription = this.service.serviceNameListservice.subscribe((data) => {
      this.globalServices = data;
      for (let obj of this.globalServices){
        if (obj.serviceName == "Target Engine Service") {
          this.targetEngineServiceResponseObj = obj;
        }
      }
    })

    this.userIdSubscription = this.service.userId.subscribe((data) => {
      this.userId = data
    })

    this.resumeSubscription = this.service.fromResume.subscribe(data => this.resume = data)

    this.WDCSubsciption = this.service.WDCListservice.subscribe((data) => {
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCListSelect = data;
        if (this.WDCListSelect.length != 0) {
          let c = ''
          c = this.WDCListSelect[0].code.toUpperCase() + '-' + this.WDCListSelect[0].description;
          this.selectedWDC = c;
          this.showSelect = true;
        }
        else {
          this.showSelect = false;
        }
        //resume
        if (this.resume) {
          this.service.pageData.subscribe(data => {
            this.pageData = data;
            let array1 = [];
            let array2 = [];
            for (let i of this.WDCListSelect) {
              if (i.code == this.pageData.code) {
                array1.push(i);
              }
              else {
                array2.push(i);
              }
            }
            if (array1.length == 0) {
              array1.push(this.pageData);
            }
            for (let i of array2) {
              array1.push(i);
            }
            this.WDCListSelect = array1;
            if (this.WDCListSelect.length != 0) {
              let c = ''
              c = this.WDCListSelect[0].code.toUpperCase() + '-' + this.WDCListSelect[0].description
              this.selectedWDC = c;
              this.showSelect = true;
            }
            else {
              this.showSelect = false;
            }
          })
          this.service.fromResume.next(false);
        }
      })
    })
  }

  ngOnDestroy() {
    this.resumeSubscription.unsubscribe();
    this.userIdSubscription.unsubscribe();
    this.WDCSubsciption.unsubscribe();
    this.serviceNameListSubscription.unsubscribe();
  }

  continue() {
    this.setSubscribersForRepairPostRepair();
    if((this.WDCListSelect.length >1) && (!this.changeWBCPopUpClickStatus)){ // If More than one WDC displayed in the drop down, show popup to the user and confirm the selected WDC Code 
      this.modalService.open(this.confirmWDCPopUp, { size: 'md' });
    } else {
      this.getRepairQualification('continue');
    }
  }

  changeWDCPopUpBtn() {
   this.changeWBCPopUpClickStatus = true;
   this.isHighlighted = true;
   setTimeout(() => {
    this.isHighlighted = false;
   }, 5000);
  }

  confirmWDC() {
    this.getRepairQualification('continue');
  }

  customerPaidPopupBtn() {
    this.setSubscribersForRepairPostRepair();
    this.getRepairQualification('customerPaid');
  }

  WarrantyClaimPopupBtn() {
    if(this.WDCListSelect.length > 1) {
      this.modalService.dismissAll();
      this.modalService.open(this.selectWDC, { size: 'md' });
    }

    if(this.WDCListSelect.length == 0) {
      this.showManage = true;
      this.service.HighlightAddManageWarrantyCode.next(true);
    }
  }

  selectWDCPopUp() {
   this.isHighlighted = true;
   setTimeout(() => {
    this.isHighlighted = false;
   }, 5000);
  }

  continue1() {
    this.modalService.open(this.customerPaidPopUp, { size: 'md' });
  }

  setSubscribersForRepairPostRepair() {
    this.service.fromResume.next(false);
    this.service.control.next(false);
    this.service.isRepairProcedure.next(false);
    this.service.isPostRepairProcedure.next(false);
    this.service.repairQualificationData.next({});
    this.service.postRepairObj.next([{}]);
    this.service.repairObj.next([{}]);
    this.service.storeGidPostRepair.next([]);
    this.service.storeGidRepair.next([]);
    this.service.navigatetoPreviousScreen.next({});
    this.service.navigatePreviousScreen.next('');
    this.service.candidateId.next('');
    this.service.candidateUidRef.next('');
    this.service.selectedDiagnosticProcedureData$.next([{}]);
    this.service.resumeRVC.next(false);
  }

  changeWDC(wdc: any) {
    this.selectedWDC = wdc.target.value;
    console.log('------------selected WDC------------???',this.selectedWDC);
  }

  getRepairQualification(value: string) {
    this.rpcClient.HideFDRSIconIfNotConnected();
    let c = this.selectedWDC.split('-');
    this.selectedWDC = c[0].toUpperCase();
    const req: any = {
      "sessionId": this.sessionId,
      "dealerCode": this.selectedWDC,
      "isDSSHRestricted": false
    }
    if (value === 'continue') {
      req["isCustomerPaid"] = false;
    } else {
      req["isCustomerPaid"] = true;
    }
    this.service.getGlobalManagedServicesDetails(this.targetEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes = data;
      if (!this.globalManagedRes) {
        this.isEnableService = true;
      } else {
        this.isEnableService = false;
      }
      if (this.isEnableService) {
        this.viewRepairQualification = true;
        this.service.getRepairPostRepairDetails(req).subscribe((data) => {
          this.viewRepairQualification = false;
          this.service.repairQualificationData.next(data);
          this.router.navigate(['/repair']);
        })
      } else {
        this.service.selectedGlobalServices.next('Target Engine Service');
        this.router.navigate(['/globalServiceEnabled']);
      }
    });
  }
}
